export default [

     {
          path: '/third-party-vendor-repository',
          name: 'VendorRepository',
          component: () => import("@/views/Page/VendorRepository/VendorRepository.vue"),
           meta: {
               title: 'VendorRepository',
          },
     }
];